import { Plus } from '@phosphor-icons/react';
import { cloneElement, ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { IJobCustomer } from 'jobs/types';
import { Color } from 'theme/enums';

import { UpsertCustomer } from './UpsertCustomer';

interface IProps {
  jobId: number;
  projectId: number;
  customer?: IJobCustomer;
  buttonElement?: ReactElement;
}

export const UpsertCustomerButton = ({ jobId, projectId, customer, buttonElement }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const onClose = () => {
    setIsOpen(false);
  };

  const button = buttonElement ? (
    cloneElement(buttonElement, {
      onClick: () => setIsOpen(true),
    })
  ) : (
    <Button
      text={t('buttonLabelAddCustomer')}
      color={Color.SUCCESS}
      startDecorator={<Plus />}
      onClick={() => setIsOpen(true)}
    />
  );

  return (
    <>
      {button}
      <UpsertCustomer
        isOpen={isOpen}
        onClose={onClose}
        jobId={jobId}
        projectId={projectId}
        customer={customer}
      />
    </>
  );
};
